/**
 * IOS-XE command abbreviation mappings.
 * Used by the answer matcher to normalize abbreviated commands.
 */

export const ABBREVIATIONS = {
  // Interface types
  'int': 'interface',
  'gi': 'gigabitethernet',
  'gig': 'gigabitethernet',
  'fa': 'fastethernet',
  'te': 'tengigabitethernet',
  'lo': 'loopback',
  'vl': 'vlan',
  'po': 'port-channel',
  'tu': 'tunnel',
  'se': 'serial',

  // Common commands
  'ro': 'router',
  'sh': 'show',
  'no': 'no',
  'conf': 'configure',
  'term': 'terminal',
  'en': 'enable',
  'ex': 'exit',
  'wr': 'write',
  'mem': 'memory',
  'ip ro': 'ip route',
  'ip int': 'ip interface',
  'ip int br': 'ip interface brief',

  // Routing
  'nei': 'neighbor',
  'net': 'network',
  'summ': 'summary',
  'addr': 'address',
  'auth': 'authentication',
  'dist': 'distribute',
  'redis': 'redistribute',

  // Show commands
  'sh ip ro': 'show ip route',
  'sh ip int br': 'show ip interface brief',
  'sh ip ospf nei': 'show ip ospf neighbor',
  'sh ip bgp sum': 'show ip bgp summary',
  'sh run': 'show running-config',
  'sh start': 'show startup-config',
  'sh ver': 'show version',
  'sh ip eigrp nei': 'show ip eigrp neighbors',
  'sh ip eigrp top': 'show ip eigrp topology',
};

/**
 * Expand abbreviations in a command string.
 * Handles multi-word abbreviations by matching longest first.
 */
export function expandAbbreviations(input) {
  let result = input.toLowerCase().trim();

  // Sort by length descending so longer abbreviations match first
  const sorted = Object.entries(ABBREVIATIONS)
    .sort((a, b) => b[0].length - a[0].length);

  for (const [abbr, full] of sorted) {
    // Match abbreviation at word boundaries
    const pattern = new RegExp(`\\b${escapeRegex(abbr)}\\b`, 'g');
    result = result.replace(pattern, full);
  }

  return result;
}

function escapeRegex(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
